import { APP_URLS } from 'constants/urls';
import { BreadCrumbsOptions } from './types';
import getDashboardHomeItem from './dashboardHomeItem';

export default function getDepartmentsBreadcrumbMap({
  pathname,
  t,
  entity,
}: BreadCrumbsOptions) {
  const dashboardHomeItem = getDashboardHomeItem({ t });
  const departmentsItem = {
    label: t('departments'),
    path: APP_URLS.dashboard.departments.index.getPathWithQuery(),
  };
  const viewDepartmentItem = {
    label: t('department-details'),
    path: APP_URLS.dashboard.departments.view.getDynamicPath({
      pathParts: {
        id: `${entity?.id}`,
      },
    }),
  };

  return [
    {
      condition: APP_URLS.dashboard.departments.index.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('departments'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.departments.add.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        departmentsItem,
        {
          label: t('create-department'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.departments.edit.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        departmentsItem,
        {
          label: t('edit-department'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.departments.view.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        departmentsItem,
        {
          label: t('department-details'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.departments.members.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        departmentsItem,
        viewDepartmentItem,
        {
          label: t('members'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.departments.accessGroups.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        departmentsItem,
        viewDepartmentItem,
        {
          label: t('access-groups'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.departments.tasks.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        departmentsItem,
        viewDepartmentItem,
        {
          label: t('linked-tasks'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.departments.interventions.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        departmentsItem,
        viewDepartmentItem,
        {
          label: t('linked-interventions'),
        },
      ],
    },
  ];
}
